var map = {
	"./blue.svg": "5b89",
	"./green.svg": "676a",
	"./mobile-monitor.svg": "166e",
	"./orange.svg": "3a20",
	"./purple.svg": "f3bc",
	"./red.svg": "181b",
	"./tan.svg": "b677",
	"./yellow.svg": "5d89"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6996";